module.exports = __webpack_public_path__ + "img/zhou-2.prt.63db0d56.jpg";